/* __next_internal_client_entry_do_not_use__ Application auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1636))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.281Z
 */ export var Application = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M14.5712 23.1429H2.57122C2.11656 23.1429 1.68053 22.9623 1.35904 22.6408C1.03755 22.3193 0.856934 21.8833 0.856934 21.4286V2.57146C0.856934 2.11681 1.03755 1.68077 1.35904 1.35928C1.68053 1.03779 2.11656 0.857178 2.57122 0.857178H16.2855",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M18 6.00003L20.5714 0.857178L23.1429 6.00003V20.5715C23.1429 21.2534 22.8719 21.9075 22.3897 22.3897C21.9075 22.872 21.2534 23.1429 20.5714 23.1429C19.8894 23.1429 19.2354 22.872 18.7532 22.3897C18.2709 21.9075 18 21.2534 18 20.5715V6.00003Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M18 16.2856H23.1429",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M4 12H11",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M4 17H9",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M4 7H13",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "Application", {
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.default
} // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
